// extracted by mini-css-extract-plugin
module.exports = {"bodys":"styles_bodys__1FqBU","loading":"styles_loading__2oKvR","dot":"styles_dot__1HTMO","wave":"styles_wave__2pFkG"};